import React from 'react';
import { motion } from 'framer-motion';
import { Map, Waves, Trees } from 'lucide-react';
export function Attractions() {
  const attractions = [{
    icon: <Waves size={32} data-id="element-16" />,
    title: 'Río a 300 metros',
    description: 'A pocos pasos para disfrutar del agua cristalina y la frescura serrana.'
  }, {
    icon: <Map size={32} data-id="element-17" />,
    title: 'Complejo termal a 800 metros',
    description: 'Relax total en aguas termales muy cerca de tu cabaña.'
  }, {
    icon: <Trees size={32} data-id="element-18" />,
    title: 'Entorno natural',
    description: 'Senderos y paisajes ideales para recorrer, caminar y descansar.'
  }];
  return <section className="py-24 bg-sand" data-id="element-19">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-21">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl text-olive-dark mb-6" data-id="element-22">
            Muy cerca de experiencias para disfrutar
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-charcoal-light" data-id="element-23">
            Además del confort del complejo, la ubicación de Cabañas El Mirador
            permite acceder fácilmente a distintos atractivos de la zona,
            ideales para complementar la estadía con naturaleza y relax.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-24">
          {attractions.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-sand-light p-4 md:p-8 rounded-2xl text-left md:text-center border border-olive/10 flex flex-row md:flex-col items-center md:items-stretch gap-4 md:gap-0" data-id="element-25">
              <div className="flex-shrink-0 inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 rounded-full bg-olive/10 text-olive md:mb-6 md:mx-auto" data-id="element-26">
                {item.icon}
              </div>
              <div data-id="element-27">
                <h3 className="text-lg md:text-xl font-medium text-charcoal mb-1 md:mb-3" data-id="element-28">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base text-charcoal-light" data-id="element-29">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}